module.exports = __webpack_public_path__ + "media/images/emblems/Zumikon-blazon-f2b6f086b363c1cc559a157473f8612d.svg";